import { Aktenzeichen } from './aktenzeichen.model';

export abstract class AktenzeichenRenderer {
	abstract render(aktenzeichen: Aktenzeichen | string): string;
}
